import { SURVEY_STATUS, SurveyStatus } from '@ps/survey-kernel';

export type SurveyMarginEntryContext = {
  readonly isManualScpiOverrideEnabled: boolean;
  readonly isMarginMaxEnabled: boolean;
  readonly status: SurveyStatus;
};

export class SurveyMarginEntryInspector {
  public constructor(private readonly _context: SurveyMarginEntryContext) {}

  public isEntryAllowed(): boolean {
    const { isManualScpiOverrideEnabled, isMarginMaxEnabled, status } =
      this._context;

    // A manual SCPI override sets the supplier price outright, so no margin can
    // derive it — true at any status.
    if (isManualScpiOverrideEnabled) {
      return false;
    }

    // Margin Max automates SCPI from the project's pace, but only once the
    // survey is actually fielding: while it is still a draft the operator is
    // free to set the margin the automation will start from.
    return !(isMarginMaxEnabled && status !== SURVEY_STATUS.DRAFT);
  }
}
